// @flow
import React from 'react';
import styles from './cityFooter.css';

type CityFooterPropsType = {
  isFixed?: boolean;
}

const CityFooter = ({
  isFixed = false,
}: CityFooterPropsType) => (
  <div
    className={`
      ${isFixed ? styles.fixed : styles.absolute}
      ${styles.cityBottomImage}
    `}
  />
);

export default CityFooter;


// WEBPACK FOOTER //
// ./src/scripts/components/CityFooter/index.jsx